import $api from '@/utils/api';
import Logger from '@/utils/logger';

export default {
  async getCities(provinceId) {
    const response = await $api.get(provinceId ? `/provinces/${provinceId}/cities` : '/cities');

    if (!response.success) {
      Logger.error(response.message);
      return { records: [] };
    }

    return response;
  },
};
